import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zh_common from './locales/zh/common.json'
import zh_report from './locales/zh/report.json'
import zh_scan from './locales/zh/scan.json'
import zh_standing from './locales/zh/standing.json'

import en_common from './locales/en/common.json'
import en_report from './locales/en/report.json'
import en_scan from './locales/en/scan.json'
import en_standing from './locales/en/standing.json'

const resources = {
    en: {
        "translation": {
            ...en_common,
            ...en_report,
            ...en_scan,
            ...en_standing,
        }
    },
    zh: {
        "translation": {
            ...zh_common,
            ...zh_report,
            ...zh_scan,
            ...zh_standing,
        }
    }
};

let params = new URLSearchParams(window.location.search);
let language = params.get('language');
if(!language) {
    language = localStorage.getItem('language');
}
// console.log({language})

i18n.use(initReactI18next).init({
    resources,
    lng: language || 'zh',
    fallbackLng: 'zh',
    interpolation: {
        escapeValue: false,
    }
});

export default i18n;